<template>
  <ion-page>
    <ion-header class="ion-no-border events-page-header" :class="{ 'page-header--scrolled': headerScrolled }">
      <ion-toolbar>
        <ion-buttons slot="start">
          <ion-back-button text="" default-href="/showcase"></ion-back-button>
        </ion-buttons>
        <ion-title>Промокоды</ion-title>
        <ion-buttons slot="end">
          <HeaderMessengerButton />
          <ion-button @click="$router.push('/admin-promo-codes/new')">
            <ion-icon :icon="addOutline"></ion-icon>
          </ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content class="main-background events-content" :fullscreen="true" @ionScroll="onContentScroll">
      <div class="ion-padding">
        <p v-if="loading" class="ion-text-center">Загрузка...</p>
        <ion-list v-else lines="full">
          <ion-item
            v-for="promo in promos"
            :key="promo.id"
            button
            @click="$router.push(`/admin-promo-codes/${promo.id}/edit`)"
          >
            <ion-label>
              <h2>{{ promo.code }}</h2>
              <p>
                −{{ promo.percentOff }}%
                <template v-if="promo.targetType === 'EVENT'">
                  · событие<template v-if="promo.eventTitle"> «{{ promo.eventTitle }}»</template><template v-else> (все)</template>
                </template>
                <template v-else-if="promo.targetType === 'ALL'"> · подписки и события</template>
                <template v-else>
                  · подписка<template v-if="promo.subscriptionTitle">
                    «{{ promo.subscriptionTitle }}»{{ subscriptionDurationHint(promo) }}
                  </template><template v-else> (все)</template>
                </template>
              </p>
              <p>
                Занято слотов: {{ promo.redemptionCount ?? 0 }}
                <template v-if="promo.maxRedemptions != null"> / {{ promo.maxRedemptions }}</template>
                <span class="hint"> (оплата + резерв до 30 мин без оплаты)</span>
              </p>
              <span v-if="promo.active === false" class="sub-badge sub-badge-draft">Выкл</span>
            </ion-label>
          </ion-item>
        </ion-list>
      </div>
    </ion-content>
  </ion-page>
</template>

<script lang="ts">
import {
  IonBackButton,
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonIcon,
  IonItem,
  IonLabel,
  IonList,
  IonPage,
  IonTitle,
  IonToolbar
} from '@ionic/vue';
import { addOutline } from 'ionicons/icons';
import { defineComponent } from 'vue';
import promoCodesService, { ILigaPromoCode } from '@/services/promo-codes.service';
import HeaderMessengerButton from '@/components/HeaderMessengerButton.vue';

export default defineComponent({
  name: 'AdminPromoCodesList',
  components: {
    HeaderMessengerButton,
    IonBackButton,
    IonButton,
    IonButtons,
    IonContent,
    IonHeader,
    IonIcon,
    IonItem,
    IonLabel,
    IonList,
    IonPage,
    IonTitle,
    IonToolbar
  },
  data() {
    return {
      promos: [] as ILigaPromoCode[],
      loading: true,
      headerScrolled: false,
      addOutline
    };
  },
  async mounted() {
    await this.load();
  },
  ionViewWillEnter() {
    void this.load();
  },
  methods: {
    onContentScroll(e: CustomEvent) {
      this.headerScrolled = (e.detail?.scrollTop ?? 0) > 16;
    },
    durationWord(days: number): string {
      const v = days % 10;
      const v2 = days % 100;
      if (v2 >= 11 && v2 <= 14) return 'дней';
      if (v === 1) return 'день';
      if (v >= 2 && v <= 4) return 'дня';
      return 'дней';
    },
    subscriptionDurationHint(promo: ILigaPromoCode): string {
      const days = promo.subscriptionDurationDays;
      if (days == null) return '';
      if (days <= 0) return ' · бессрочная';
      return ` · ${days} ${this.durationWord(days)}`;
    },
    async load() {
      this.loading = true;
      try {
        this.promos = await promoCodesService.list();
      } catch (e) {
        console.error(e);
        this.promos = [];
      }
      this.loading = false;
    }
  }
});
</script>

<style scoped>
.sub-badge {
  display: inline-block;
  margin-top: 4px;
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 11px;
}
.sub-badge-draft {
  background: rgba(255, 193, 7, 0.2);
  color: #ffc107;
}
.hint {
  font-size: 11px;
  opacity: 0.7;
}
</style>
